import { combineReducers } from "redux";
import { settlementReducer } from '../../views/finance-user/reducer';

export default combineReducers({
  settlementBankInfo: settlementReducer
});